import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Shipment } from '@graphql-types';
import { ShipmentStatusComponent } from '@ui/shipment-status/shipment-status.component';

@Component({
  selector: 'lig-shipment-search-option',
  standalone: true,
  imports: [MatIconModule, ShipmentStatusComponent],
  templateUrl: './shipment-search-option.component.html',
  styleUrls: ['./shipment-search-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentSearchOptionComponent {
  option = input.required<Shipment>();
}
